module.exports = __webpack_public_path__ + "static/media/Product_Photos_Cookies.4bff4945.png";